/*
|--------------------------------------------------------------------------
| Views: Flipp
|--------------------------------------------------------------------------
*/
/**
 * Loads views.flipp.callbacks after view is rendered
 */
__gh__webApp.views.flipp = {

	"callbacks": function(){
		__gh__webApp.ads.flipp.loadWidgetElement();
	}
};
